<template>
  <div class="header_">
    <!-- 导航 -->
    <el-row>
      <el-header style="text-align:right;font-size:12px;overflow: hidden;text-overflow:ellipsis;white-space:nowrap">
         <el-col :span="3" class="el_col">
             IT1024IM
         </el-col>
         <el-col :span="21">
            <el-dropdown>
              <i class="el-icon-setting" style="margin-right: 15px"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="exit_login">退出</el-dropdown-item>
                <el-dropdown-item @click.native="zaixian">在线</el-dropdown-item>
                <el-dropdown-item @click.native="lixian">离线</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span @click="exit_login" style="cursor: pointer;">
               {{name}}
            </span>
         </el-col>
      </el-header>
    </el-row>

  </div>
</template>

<script>
//全局属性
import global from '@/common/common.vue'
export default {
  name: 'header_',
  data(){
     return{
         name:null,
         geturl: global.it1024imLogin,
     }
  },
  created(){
     //获取sessionStorage的用户名
     this.name = sessionStorage.getItem("uname");
  },
  methods: {
     //退出用户
     exit_login(){
         this.$confirm('您确定退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //删除sessionStorage
          sessionStorage.removeItem("uname");
          this.$notify({
            title: '提示',
            message: '退出成功，即将跳转登录页',
            type: 'success'
          });
          setTimeout(()=>{
            //跳转到登录
            this.$router.push({path:'/login'})
          },3000)
        }).catch(() => {
             this.$notify.info({
                title: '提示',
                message: '取消成功'
             });          
        });
     },
     //设置在线
     zaixian(){
       this.$http.post(this.geturl,{state:'true'},{emulateJSON:true}).then(res=>{
           if(res.body){
             this.$notify({
                title: '提示',
                message: '已设置在线',
                type: 'success'
             });
           }
       });
     },
     //设置离线
     lixian(){
       this.$http.post(this.geturl,{state:'false'},{emulateJSON:true}).then(res=>{
           if(res.body){
             this.$notify({
                title: '提示',
                message: '已设置离线',
                type: 'warning'
              });
           }
       });
     }
  }
}

</script>


<style scoped>
 .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .el_col{
    text-align: left;
    font-size: 26px;
  }
  .el-aside {
    color: #333;
  }
  @media screen and (max-width: 800px) {
     .el_col{
        width: 65% !important;
     }
     .el-col-21 {
         width: 30% !important;
        float: right;
     }
  }
</style>



// WEBPACK FOOTER //
// src/components/header_.vue